import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import appReducer from './app/reducers';
import gameReducer from './game/reducers';
import promotionsReducer from './promotions/reducers';
import cashierReducer from './cashier/reducers';

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

export const store = configureStore({
  reducer: {
    app: appReducer,
    game: gameReducer,
    promotions: promotionsReducer,
    cashier: cashierReducer,
  },
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sentryReduxEnhancer),
});

export type RootState = ReturnType<typeof store.getState>;
